import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';

import AcademyMenuMovil from 'components/UI/AcademyMenuMovil/AcademyMenuMovil';

import { logOut } from 'store/user-actions';
import { getLoginMenuData } from 'constants/LoginMenu';
import { getNoUserMenuData } from 'constants/NoUserMenu';

import classes from './MovilMenu.module.css';

const url = window.location.pathname.split('/');

const MovilMenu = () => {
  const { t } = useTranslation(['header']);
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const userInfo = useSelector(state => state.userInfo);
  const [state, setState] = useState(false);

  const toggleDrawer = () => () => {
    setState(!state);
  };

  const logoutUser = () => {
    dispatch(logOut());
  };

  return (
    <div className={classes.movilMenuContainer}>
      <IconButton
        onClick={toggleDrawer(state, true)}
        edge="start"
        color="inherit"
        aria-label="menu"
        sx={{ mr: 2 }}
      >
        <MenuIcon className={classes.menuIcon} />
      </IconButton>
      <Drawer
        anchor="left"
        open={state}
        onClose={toggleDrawer(state, false)}
      >
        {userInfo.data.usuario ? (
          <ul className={classes.menuContainer}>
            {getLoginMenuData().map(item => (
              <li className={classes.itemMenu} key={item.link}>
                {item.openInDiferentPage ? (
                  <Button
                    className={classes.itemLink}
                    component="a"
                    href={item.link}
                  >
                    {t(item.text)}
                  </Button>
                ) : (
                  <Link
                    className={classes.itemLink}
                    onClick={toggleDrawer(state, false)}
                    to={item.link}
                  >
                    {t(item.text)}
                  </Link>
                )}
              </li>
            ))}
            <Divider />
            {dataAcademy.menu.length > 0 && url[2] !== 'course' && (
              <AcademyMenuMovil menu={dataAcademy.menu} />
            )}
            <Divider />
            <li className={classes.itemMenu}>
              <Button
                className={classes.itemLink}
                onClick={logoutUser}
              >
                Cerrar sesión
              </Button>
            </li>
          </ul>
        ) : (
          <ul className={classes.menuContainer}>
            {getNoUserMenuData().map(item => (
              <li className={classes.itemMenu} key={item.link}>
                {item.openInDiferentPage ? (
                  <Button
                    className={classes.itemLink}
                    component="a"
                    href={item.link}
                  >
                    {t(item.text)}
                  </Button>
                ) : (
                  <Link
                    className={classes.itemLink}
                    onClick={toggleDrawer(state, false)}
                    to={item.link}
                  >
                    {t(item.text)}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        )}
      </Drawer>
    </div>
  );
};

export default MovilMenu;
